import gql from 'graphql-tag';

export const getSubKeys = gql`
  query ($application: Int) {
    getSubKeys(application: $application) {
      subKeyId
      key
      alias
      type
    }
  }
`
